import type { FieldOption } from '@atlassian/company-hub-common/config-panel/config-field-dropdown';

import { CardSize } from '../../../../types';
import { messages } from './messages';

export const SIZE_OPTIONS_CARDS: FieldOption<CardSize>[] = [
	{
		label: messages.sizeSmallDropDownItemLabel,
		value: CardSize.SMALL,
	},
	{
		label: messages.sizeMediumDropDownItemLabel,
		value: CardSize.MEDIUM,
	},
	{
		label: messages.sizeLargeDropDownItemLabel,
		value: CardSize.LARGE,
	},
];
